declare namespace $ {

	export class $mol_icon_apps extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=apps.view.tree.d.ts.map